/** Public tenant portal sign-in URL — always share app.shahosuite.com in production. */
const PRODUCTION_APP = 'https://app.shahosuite.com';

const LEGACY_HOSTS = [
  'shahosuitefrontstorage.z33.web.core.windows.net',
  'shahosuitefrontstorage.blob.core.windows.net',
];

function resolvePortalOrigin(): string {
  if (typeof window === 'undefined') return PRODUCTION_APP;
  const { hostname, origin } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return origin;
  if (LEGACY_HOSTS.some(h => hostname.includes(h))) return PRODUCTION_APP;
  if (hostname === 'app.shahosuite.com' || hostname.endsWith('.shahosuite.com')) return origin;
  return PRODUCTION_APP;
}

export function getTenantPortalLoginUrl(): string {
  return `${resolvePortalOrigin()}/tenant/login`;
}

export function getTenantPortalLabel(): string {
  const url = getTenantPortalLoginUrl();
  try {
    const u = new URL(url);
    return `${u.host}${u.pathname}`;
  } catch {
    return url.replace(/^https?:\/\//, '');
  }
}
